// ...existing code...
import React, { useState, useEffect } from "react";
import axios from "axios";
import { GoInfinity } from "react-icons/go";
import { FaStar } from "react-icons/fa";
import { MdLocalOffer } from "react-icons/md";
import AllProduct from "./AllProduct";
import { CiMobile4 } from "react-icons/ci";
import { HiOutlineComputerDesktop } from "react-icons/hi2";
import { BsSmartwatch } from "react-icons/bs";
import { CiHeadphones, CiCamera } from "react-icons/ci";
import { LuGamepad } from "react-icons/lu";
import { MdOutlineExpandMore } from "react-icons/md";
const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
// ...existing code...

const ProductTabs = () => {
  // initial All tab
  const initialTabs = [
    { id: 1, label: "All", icon: GoInfinity, categoryId: null },
  ];

  const [tabs, setTabs] = useState(initialTabs);
  const [activeTab, setActiveTab] = useState(initialTabs[0].id);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchCategories = async () => {
      setLoading(true);
      try {
        const token =
          sessionStorage.getItem("accessToken") ||
          localStorage.getItem("accessToken");
        const res = await axios.post(
          `${API_BASE_URL}/product_category/get-categories`,
          { filters: {}, page: 1, limit: 10 },
          {
            headers: {
              "Content-Type": "application/json",
              token,
            },
          }
        );

        if (res.data?.success && Array.isArray(res.data.result?.ProductCategories)) {
          const categories = res.data.result.ProductCategories;
          // build dynamic tabs (start id at 2 so All remains 1)
          const dynamic = categories.map((cat, idx) => ({
            id: idx + 2,
            label: cat.title || `Category ${idx + 1}`,
            icon: GoInfinity, // use a default icon; swap if you want per-category icons
            categoryId: cat.id,
          }));
          setTabs([initialTabs[0], ...dynamic]);
        } else {
          // keep default tabs if API returns unexpected data
          setTabs(initialTabs);
        }
      } catch (err) {
        console.error("Failed to fetch categories:", err);
        setTabs(initialTabs);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  const selectedTab = tabs.find((t) => t.id === activeTab) || tabs[0];

  return (
    <div className="w-full mt-10 mx-auto">
      {/* Tabs Header */}
      <div className="flex gap-10 mb-4 overflow-x-auto">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          return (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex flex-col items-center gap-2 px-4 py-2 font-semibold relative 
                ${
                  activeTab === tab.id
                    ? "border-2 rounded-xl border-gray-200"
                    : "border-4 border-transparent hover:bg-gray-50"
                }`}
            >
              <Icon className="text-[30px]" />
              <span className="text-[14px]">{tab.label}</span>
            </button>
          );
        })}
      </div>

      {/* Tabs Content */}
      <div className="p-4 bg-gray-50 rounded">
        {/* Pass selected categoryId and label to AllProduct.
            AllProduct can decide how to use categoryId (filtering etc.). */}
        <AllProduct title={selectedTab.label} categoryId={selectedTab.categoryId} loadingCategories={loading} />
      </div>
    </div>
  );
};

export default ProductTabs;
// ...existing code...